import Cookies from 'js-cookie'
import { constantRouterMap } from '../router'

const SupportKey = 'supportKey'
export function getSupport() {
  return Cookies.get(SupportKey)
}

export function setSupport(isSupport) {
  return Cookies.set(SupportKey, isSupport, { expires: 3 })
}

export function setCookie(key, value, expires) {
  return Cookies.set(key, value, { expires })
}

export function getCookie(key) {
  return Cookies.get(key)
}

// 최근 본 상품 cookie 는 변경 감지가 안돼 event 가 있는 localstorage 사용 했음...
export function getRecentlyViewProduct() {
  return localStorage.getItem('RVP')
    ? JSON.parse(localStorage.getItem('RVP'))
    : []
}

export function setRecentlyViewProduct(item) {
  let viewList = []
  if (localStorage.getItem('RVP')) {
    viewList = JSON.parse(localStorage.getItem('RVP'))
  }
  if (viewList.filter(i => i.id === item.id).length > 0) {
    console.log(viewList.map(i => i.id).indexOf(item.id))
    viewList.splice(viewList.map(i => i.id).indexOf(item.id), 1)
  }

  if (viewList.length >= 4) {
    viewList.splice(3, 1)
  }

  viewList.unshift(item)
  localStorage.setItem('RVP', JSON.stringify(viewList))

  // event 생성
  window.dispatchEvent(
    new CustomEvent('RVP-changed', {
      detail: {
        storage: JSON.parse(localStorage.getItem('RVP'))
      }
    })
  )
}



// WEBPACK FOOTER //
// ./src/utils/support.js